<template>
  <!-- payment - add / edit -->
  <div class="p-mypage__payment p-mypage__payment--edit mypage-bloc">
    <div class="mypage-bloc__head">
      <h2>{{ $t('TITLE_ADDITIONAL_PAYMENT_METHODS') }}</h2>
      <!-- <h2>支払方法の確認・変更</h2> -->
    </div>
    <div class="mypage-bloc__content">

      <!-- payment form -->
      <div class="payment__form">
        <h3>{{ $t('TEXT_REQUIRED_FIELDS') }}</h3>
        <p><span>＊</span>{{ $t('TEXT_REQUIRED_FIELD') }}</p>

        <!-- <form> -->
        <div class="p-creditcard-edit__form c-form-parts">

          <div class="c-creditcard c-creditcard--front">
            <div class="cred-info">
              <dl class="cred-number">
                <dt>{{ $t('LABEL_CARD_NUMBER') }} / {{ $t('LABEL_CARD_NAME') }}<span>＊</span></dt>
                <dd>
                  <div class="input-area" :class="{ 'is-error': v$.card_number.$error || creditCardStore.creditCardFormErrors.card_1 || creditCardStore.creditCardFormErrors.card_2 || creditCardStore.creditCardFormErrors.card_3 || creditCardStore.creditCardFormErrors.card_4}"><!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                    <input id="input__creditcard-number" v-model="creditCardStore.creditCardForm.card_number" type="text" placeholder="CARD NUMBER" maxlength="19" pattern="[0-9]*" :disabled="creditCardStore.isCreditCardEdit" data-lpignore="true" autocomplete="off" data-form-type="other">
                  </div>
                </dd>
              </dl>
              <dl class="cred-expiration">
                <dt>{{ $t('LABEL_EFFECTIVE_DATE') }}<span>＊</span></dt>
                <dd>
                  <div class="input-area" :class="{ 'is-error': v$.expiration_date.$error || creditCardStore.creditCardFormErrors.expire_month || creditCardStore.creditCardFormErrors.expire_year}"><!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                    <input id="input__creditcard-expiration" v-model="creditCardStore.creditCardForm.expiration_date" type="text" placeholder="MM/YY" maxlength="5" pattern="[0-9]*">
                  </div>
                </dd>
              </dl>
            </div>
            <div class="cred-name" :class="{ 'is-error': v$.holder_name.$error || creditCardStore.creditCardFormErrors.holder_name }">
              <div class="input-area"><!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                <input id="input__creditcard-holder" type="text" placeholder="NAME" v-model="creditCardStore.creditCardForm.holder_name" pattern="[\uFF21-\uFF3A|\uFF41-\uFF5A]*">
              </div>
            </div>
            <ul class="cred-brand">
              <li class="visa" :class="{ 'is-show': creditCardStore.isCreditCardEdit && creditCardStore.creditCardForm.card_brand_code === CARD_BRAND_VISA }"><img src="@/assets/img/ui_parts/creditcard_logo_visa.png" alt="VISA"></li>
              <li class="jcb" :class="{ 'is-show': creditCardStore.isCreditCardEdit && creditCardStore.creditCardForm.card_brand_code === CARD_BRAND_JCB }"><img src="@/assets/img/ui_parts/creditcard_logo_jcb.png" alt="JCB"></li>
              <li class="master" :class="{ 'is-show': creditCardStore.isCreditCardEdit && creditCardStore.creditCardForm.card_brand_code === CARD_BRAND_MASTER }"><img src="@/assets/img/ui_parts/creditcard_logo_master.png" alt="Master Card"></li>
              <li class="amex" :class="{ 'is-show': creditCardStore.isCreditCardEdit && creditCardStore.creditCardForm.card_brand_code === CARD_BRAND_AMERICAN_EXPRESS }"><img src="@/assets/img/ui_parts/creditcard_logo_amex.png" alt="American Express"></li>
              <li class="diners"><img src="@/assets/img/ui_parts/creditcard_logo_diners.png" alt="Diners Club"></li>
            </ul>
            <div class="cred-validation">
              <p class="error-txt" v-for="err in creditCardStore.creditCardFormErrors">{{ err }}</p>
              <p class="error-txt" v-if="creditCardStore.creditCardFormErrorsMsg">{{ creditCardStore.creditCardFormErrorsMsg }}</p>
              <p class="error-txt" v-for="err in v$.$errors.slice(0, 3)">{{ $t(err.$message) }}</p>
            </div>
          </div>

          <div class="c-creditcard c-creditcard--back">
            <dl class="cred-cvc">
              <dt>{{ $t('LABEL_SECURITY_CODE_2') }}<span>＊</span><button class="c-btn__cvc-open"><img src="@/assets/img/ui_parts/svg/security_code_info.svg" alt="セキュリティーコードとは？" /></button></dt>
              <dd>
                <div class="input-area" :class="{ 'is-error': v$.cvv.$error || creditCardStore.creditCardFormErrors.cvv }"><!-- TODO: When there is an error, add "is-error" class to this "div.input-area" -->
                  <input id="input_creditcard-cvv" type="text" v-model="creditCardStore.creditCardForm.cvv" placeholder="000" maxlength="4" pattern="[0-9]*">
                </div>
              </dd>
            </dl>
            <div class="cvc-validation">
              <p class="error-txt" v-if="creditCardStore.creditCardFormErrors.cvv">{{ creditCardStore.creditCardFormErrors.cvv }}</p>
              <p class="error-txt" v-if="v$.cvv.$error">{{ $t(v$.cvv.$errors[0].$message) }}</p>
            </div>
          </div>
        </div>

        <div class="p-creditcard-edit__btn">
          <div v-if="creditCardStore.isCreditCardEdit" class="c-btn c-btn--cardedit-submit"><input type="button" :value="$t('LABEL_UPDATE_BUTTON')" @click="updateCreditCard()"></div>
          <div v-else class="c-btn c-btn--cardedit-submit"><input type="button" :value="$t('LABEL_REGISTER_BUTTON')" @click="registerCreditCard()"></div>
          <div class="c-btn c-btn--cardedit-cancel"><button @click="creditCardStore.resetCreditCardForm()" type="button">キャンセル</button></div>
        </div>
        <!-- </form> -->

        <!-- TODO: .is-loading -->
        <div class="c-loader p-cardedit-edit__loading"><span class="c-loader__icon"></span></div>
      </div>

      <!-- what's cvc -->
      <div class="payment__cvc">
        <div class="p-cvc__info">
          <h2>{{ $t('TEXT_ABOUT_CVV') }}</h2>
          <div class="p-cvc__sample">
            <h3>VISA / Master / JCB{{ $t('LABEL_CREDIT_CARD_BACK_SIDE') }}</h3>
            <ul>
              <li><span class="img-box"><img src="@/assets/img/ui_parts/creditcard_cvc_fig01.png" alt="cvc sample" /></span></li>
              <li><span class="img-box"><img src="@/assets/img/ui_parts/creditcard_cvc_fig02.png" alt="cvc sample" /></span></li>
            </ul>
          </div>
          <div class="p-cvc__sample">
            <ul>
              <li>
                <h3>Diners{{ $t('LABEL_CREDIT_CARD_BACK_SIDE') }}</h3>
                <span class="img-box"><img src="@/assets/img/ui_parts/creditcard_cvc_fig03.png" alt="cvc sample" /></span>
              </li>
              <li>
                <h3>AMEX{{ $t('LABEL_CREDIT_CARD_FRONT_SIDE') }}</h3>
                <span class="img-box"><img src="@/assets/img/ui_parts/creditcard_cvc_fig04.png" alt="cvc sample" /></span>
              </li>
            </ul>
          </div>
          <p class="info-txt">{{ $t('TEXT_CVV_INFO') }}</p>
          <p class="info-sub">{{ $t('TEXT_CVV_SUB_TITLE') }}</p>
        </div>
        <div class="p-cvc__btn">
          <button class="c-btn__cvc-close"><img src="@/assets/img/ui_parts/creditcard_cvc_close.png" alt="close" /></button>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import {useCreditCardStore} from "@/stores/creditCardStore";
import {useVuelidate} from "@vuelidate/core";
import {getCreditCardRegisterRules} from "@/validations/creditCardValidation";
import {CARD_BRAND_AMERICAN_EXPRESS, CARD_BRAND_JCB, CARD_BRAND_MASTER, CARD_BRAND_VISA} from "@/data/constants";

const creditCardStore = useCreditCardStore();
const v$ = useVuelidate(getCreditCardRegisterRules(creditCardStore), creditCardStore.getCreditCardFormInputs);

async function registerCreditCard() {    
    if (!await v$.value.$validate()) {
        $('html, body').animate({ scrollTop: 0 }, 300);
        return false;
    }
    if (await creditCardStore.registerCreditCard()) {
        hideCreditCardList();
    }
}
  
async function updateCreditCard() {
    if (!await v$.value.$validate()) {
        $('html, body').animate({ scrollTop: 0 }, 300);
        return false;
    }
    if (await creditCardStore.updateCreditCard()) {
        hideCreditCardList();
    }
}

function hideCreditCardList() {
    $('.p-mypage__payment--list').css('display', 'none').fadeIn(400);
    $('.p-mypage__payment--edit').removeAttr('style');
    $('html, body').animate({ scrollTop: 0 }, 300);
}

</script>